import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import typography from "../../theme/typography";

import LogoImage from "../../assets/logo/logo_youth.png";

import LongButton from "../shared/LongButton";

const EXTERNAL_LINK = "https://campaigns.kr/campaigns/771";

const Page = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  background-color: #1e1e1e;
  color: ${(props) => props.theme.color.white};
`;

const Image = styled.img`
  margin-bottom: 15px;
`;

const PlaceHolder = styled.div`
  width: 360px;
  height: 340px;
`;

const Title = styled.div`
  span {
    ${typography.mainText2};
    display: block;
    margin-bottom: 7px;
  }
  strong {
    color: ${(props) => props.theme.color.primary};
    font-weight: 600;
    font-size: 30px;
    display: block;
    margin-bottom: 20px;
  }
`;

const HashText = styled.span`
  ${typography.mainText2};
  margin-bottom: 20px;
`;

const Content = styled.p`
  ${typography.mainText1};
  margin-bottom: 10px;
  b {
    color: ${(props) => props.theme.color.primary};
  }
`;

const SubText = styled.span`
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 32px;
`;

const Divider = styled.hr`
  width: 320px;

  background-color: ${(props) => props.theme.color.primary};
  border: 0;
  height: 1px;

  margin-bottom: 39px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  margin-bottom: 38px;
`;

const ButtonContainer = styled.div`
  p {
    ${typography.mainText2};
    margin-bottom: 17px;
  }
`;

const Logo = styled.img``;

const ResultPageLayout = ({ img, title, hashText, children }) => {
  const [loading, setLoading] = useState(true);

  const copyLink = async () => {
    await navigator.clipboard.writeText(window.location.href);
    alert("링크가 복사되었습니다.");
  };

  return (
    <Page>
      {loading && <PlaceHolder />}
      <Image src={img} alt="" onLoad={() => setLoading(false)} />

      <Title>
        <span>당신은</span>
        <strong>{title}</strong>
      </Title>

      <HashText>#{hashText}</HashText>

      <Content>{children}</Content>
      <SubText>모아진 의견은 서울시 기후환경본부에 전달될 예정입니다:)</SubText>

      <Divider />

      <Buttons>
        <ButtonContainer>
          <p>캠페인 참여하기</p>
          <a href={EXTERNAL_LINK} target="_blank" rel="noreferrer">
            <LongButton text="쓰레기 줄이는 정책 제안하기" />
          </a>
        </ButtonContainer>

        <ButtonContainer>
          <p>친구에게 공유하기</p>
          <LongButton text="링크 복사하기" onClick={copyLink} />
        </ButtonContainer>

        <ButtonContainer>
          <p>한 번 더 도전하기</p>
          <Link to="/">
            <LongButton text="처음으로 돌아가기" />
          </Link>
        </ButtonContainer>
      </Buttons>

      <a
        href="https://www.peoplepower21.org/Youth"
        target="_blank"
        rel="noreferrer"
      >
        <Logo src={LogoImage} alt="세상을 바꾸는 청년 참여연대" />
      </a>
    </Page>
  );
};

export default ResultPageLayout;
